import React, { useState, useEffect } from 'react';
import './TopBanner.scss';

export default function TopBanner() {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const handleScroll = () => setHidden(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.body.classList.toggle('top-banner-visible', !hidden);
    return () => document.body.classList.remove('top-banner-visible');
  }, [hidden]);

  return (
    <a href="/contact-us-solution" className={`top-banner${hidden ? ' top-banner--hidden' : ''}`}>
      <span className="top-banner__text">
        <strong>Webinar:</strong> What a Smart Supply Chain Looks Like at Global Scale — Register Now &#8594;
      </span>
    </a>
  );
}
